<div *ngIf="isLoadingEngagementStats" class="loading-container">
	<qai-loading [size]="'medium'"></qai-loading>
</div>

<div class="container" *ngIf="isTranslationLoaded && !isLoadingEngagementStats">
	<div class="stats">
		<qai-reporting-card [title]="'reportingV2.AVERAGE_SESSIONS_PER_ACTIVE_USER' | transloco" [value]="this.localeService.formatNumber(engagementStats?.avgSessionsPerActiveUser || 0)" align="start"></qai-reporting-card>
		<qai-reporting-card [title]="'reportingV2.HOURS_IN_SIMULATIONS' | transloco" [value]="formatTotalDuration(engagementStats?.totalDurationInSeconds || 0)" align="start"></qai-reporting-card>
		<qai-reporting-card [title]="'reportingV2.AVERAGE_SESSIONS_TO_PROFICIENCY' | transloco" [value]="this.localeService.formatNumber(engagementStats?.avgSessionsToCompleted || 0)" align="start"></qai-reporting-card>
		<qai-reporting-card [title]="'reportingV2.PERCENT_PROFICIENT' | transloco" [tooltip]="{
			icon: 'info-circle',
			content: 'reportingV2.PROFICIENT_TOOLTIP' | transloco
			}" [value]="this.localeService.formatNumber(engagementStats?.percentCompleted || 0) + '%'" align="start"></qai-reporting-card>
	</div>
	<div class="donut-container">
		<div #donutChartContainer class="donut-chart-container"></div>
	</div>
</div>